import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import LanguageSelectorObjectLearning from "@components/InputCst/LanguageSelector/ObjectLearning";
import { useLoTranslationContext } from "../hooks/useLoTranslation";

interface SectionTitleTranslationProps {
  sectionId?: number;
}

export default function SectionTitleTranslation({
  sectionId,
}: SectionTitleTranslationProps) {
  const { t } = useTranslation("lo-alternatives");
  const { id: corporateId = "" } = useParams();
  const translation = useLoTranslationContext();

  // The context is available when editing an existing LO. New sections need
  // to be saved first so their translations can reference a persisted ID.
  if (
    !corporateId ||
    sectionId == null ||
    !translation?.languages?.secondary_languages?.length
  ) {
    return null;
  }

  return (
    <LanguageSelectorObjectLearning
      languages={translation.languages}
      id={corporateId}
      idObject={sectionId}
      col={{
        entityType: "sections",
        accessorKey: "title",
        header: t("section-title.label"),
      }}
    />
  );
}
